export { default as VirtualServiceAgentHeader } from './virtual-service-agent-header';
